const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
import {
	useBlockProps,
	__experimentalPanelColorGradientSettings as PanelColorGradientSettings
} from '@wordpress/block-editor';

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/descriptif-thematise", {
	title: __("Descriptif thématisé", "wp-apidae"), // Block title.
	description: __("Affiche les descriptifs thématisés.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.textTheme
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		themes: {
			type: "array",
			default: [],
		},
		align: {
			type: 'string',
			default: '',
		},
		text_color: {
			type: 'string',
			default: '',
		},
		background_color: {
			type: 'string',
			default: '',
		},
		background_gradient: {
			type: 'string',
			default: '',
		}
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;

			var fieldsOptions = [
				{ value: null, label: 'Choisir un descriptif', disabled: true },
				{ value: 6604, label: 'Alerte visiteurs' },
				{ value: 6303, label: 'Bon cadeau' },
				{ value: 5157, label: 'Conditions d\'accès des véhicules motorisés' },
				{ value: 5154, label: 'Conseils et suggestions' },
				{ value: 5480, label: 'Conseils pour le photographe' },
				{ value: 6143, label: 'Dispositions spéciales COVID 19' },
				{ value: 5159, label: 'Histoire, culture et patrimoine' },
				{ value: 6375, label: 'Informations sur ouverture anticipée' },
				{ value: 6719, label: 'JO 2024' },
				{ value: 5352, label: 'Label "Vignobles et Découvertes"' },
				{ value: 5366, label: 'Menu spécial pour les fêtes' },
				{ value: 6571, label: 'Nouveauté 2022' },
				{ value: 6724, label: 'Offres promotionnelles' },
				{ value: 6136, label: 'Portrait' },
				{ value: 5870, label: 'Recette locale' },
				{ value: 6139, label: 'Restauration et ravitaillement' },
				{ value: 6413, label: 'Service pour les croisiéristes' },
				{ value: 5162, label: 'Services pour les cyclistes' },
				{ value: 5160, label: 'Services pour les enfants' },
				{ value: 5216, label: 'Services pour les motards' },
				{ value: 5161, label: 'Services pour les randonneurs' },
				{ value: 6527, label: 'Topo/pas à pas' },
				{ value: 5417, label: 'Tourisme durable' },
				{ value: 6301, label: 'Vente à emporter' },
			];

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
							<div class="wpdae_multiple_selectcontrol">
						<SelectControl
							multiple
							label={ __( 'Choisir les descriptifs thématisés' ) }
							help={ __( 'CTRL + clic pour sélectionner plusieurs éléments' ) }
							value={ attributes.themes }
							options={fieldsOptions}
							onChange={ newValue => {
								props.setAttributes({
									themes: newValue,
								});
							}}
						/>
						</div>
						</PanelBody>
						<PanelColorGradientSettings
					title={ __("Colors") }
					settings={ [ {
						colorValue: attributes.text_color,
						label:__("Texte"),
						onColorChange:(newValue) => props.setAttributes({text_color: newValue }),
					},
					{
						colorValue: attributes.background_color,
						gradientValue: attributes.background_gradient,
						label:__("Arrière-plan"),
						onColorChange:(newValue) => props.setAttributes({background_color: newValue }),
						onGradientChange:(newValue) => props.setAttributes({background_gradient: newValue }),
					} ] }
				>
				</PanelColorGradientSettings>
					</InspectorControls>
				,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/descriptif-thematise"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
